module.exports = __webpack_public_path__ + "static/media/52561441_2452970831444760_4023275782343229440_o.f37aeb33.jpg";